import React, { useContext } from 'react';
import SearchContext from '../data/FunnelbackContext';
import styles from '../../css/functional.module.scss';

function SearchResultsToDisplay() {
    const { validatedNumberOfResultsToDisplayData, numberOfSearchResultsToDisplay, setNumberOfSearchResultsToDisplay } =
        useContext(SearchContext);

    return (
        <div className={`${styles.numberOfResults} funnelback-instant-search-number-of-results-to-display`}>
            <select
                name="results per page filter"
                value={numberOfSearchResultsToDisplay}
                onChange={(e) => setNumberOfSearchResultsToDisplay(e.target.value)}
            >
                {validatedNumberOfResultsToDisplayData.map((value, i) => {
                    const key = `number-of-results-to-display-${i}`;
                    return (
                        <option key={key} value={value} name={value}>
                            {value}
                        </option>
                    );
                })}
            </select>
            <svg aria-hidden="true">
                <title>Down Arrow</title>
                <use href="#chevron-down" />
            </svg>
        </div>
    );
}

export default SearchResultsToDisplay;
